module.exports = __webpack_public_path__ + "static/media/sc_31_i.693b1352.png";